<template>
  <div class="my-0 mx-auto relative w-full max-w-full overflow-x-hidden">
    <div class="min-h-0 box-border w-full my-0 mx-auto">
      <div class="flex flex-row m-2 sm:m-4 text-base sm:text-lg gap-2 items-center flex-wrap">
        <span class="break-words">{{ $t('TravelBuddyHistory.showCompleted') }}</span>
        <ToggleSwitch class="relative inline-block toggle-width shrink-0" v-model="allTravelBuddies"/>
      </div>
      <div class="relative mx-2 sm:mx-4">
        <div v-if="travelBuddyHistory.length > 0">
          <travel-buddy-history-card-component
            v-for="meeting in travelBuddyHistory"
            :key="meeting._id"
            :meeting="meeting">
          </travel-buddy-history-card-component>
        </div>
        <div v-else class="py-6">
          <h2 class="text-gray-700 mb-2">
            {{ $t('TravelBuddyHistory.noHistoryText', {text: featureName}) }}
          </h2>
          <p class="text-gray-500">
            {{ $t('TravelBuddyHistory.noMeetingsMessage', {text: featureName}) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TravelBuddyHistoryCardComponent from './TravelBuddyHistoryCardComponent.vue';
import { ToggleSwitch } from 'primevue';
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';

export default {
  name: 'TravelBuddyHistoryComponent',
  props: [],
  components: { TravelBuddyHistoryCardComponent, ToggleSwitch },
  data() {
    return {
      allTravelBuddies: false,
    };
  },
  computed: {
    featureName() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'travelBuddyHistory',
        this.$t('FallbackTexts.travelBuddyHistory'),
        this.$i18n?.locale,
      );
    },
    travelBuddyHistory() {
      let history = this.$store.getters.getTravelBuddyHistory;
      if (!this.allTravelBuddies) {
        const hasFeedbackContent = (entry) => Boolean(entry?.feedback?.trim?.());

        // show meetings that still need own feedback, even when they are completed/skipped
        history = history.filter((e) => {
          const statusAllowsFeedback = ['completed'].includes(e.meetingStatus);
          if (!statusAllowsFeedback) {
            return true;
          }
          const ownFeedback = e.meetingFeedback
            ?.find((m) => String(m.user) !== String(e.otherMember._id));
          return !hasFeedbackContent(ownFeedback);
        });
      }
      return history;
    },
  },
  async mounted() {
    await this.$store.dispatch('getTravelBuddyHistory');
  },
};
</script>
<style scoped>
@media screen and (max-width: 400px){
  .toggle-width {
    width: 3.25rem !important;
  }
}
</style>
